export default __webpack_public_path__ + "static/media/BQ-SE.d70da59f.svg";